import { useEffect, useState } from 'react';
import { useRouteMatch } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { PATHS } from 'src/common/constants';
import {
  FetchContactByIdResult,
  useContactAPI,
  UseContactAPIReturn,
} from 'src/SharedCustomHooks/UseContactAPI/useContactAPI';
import { selectAuthenticatedUser } from 'src/store/selectors/auth';
import { SidebarContextRow } from '../Components/SidebarContextTree';

interface RouteParams {
  id: string;
}

const useContactContextRows = (): SidebarContextRow[] | null => {
  const match = useRouteMatch<RouteParams>({ path: PATHS.CONTACTS_VIEW });
  const contactId: string = match?.params?.id ?? '';

  const user: any = useSelector(selectAuthenticatedUser);

  const { fetchContactById }: UseContactAPIReturn = useContactAPI();

  const [contact, setContact] = useState<any>(null);

  useEffect(() => {
    if (!contactId || !user?.id) {
      return;
    }

    let active: boolean = true;

    const loadContact = async () => {
      const result: FetchContactByIdResult =
        await fetchContactById(contactId);

      if (active && result.ok) {
        setContact(result.contact);
      }
    };

    loadContact();

    return () => {
      active = false;
    };
  }, [contactId, user?.id]);

  if (!match || !contactId) {
    return null;
  }

  const fullName: string = contact
    ? `${contact.firstname ?? ''} ${contact.lastname ?? ''}`.trim()
    : '';

  return [
    {
      label: fullName,
      path: PATHS.CONTACTS_VIEW.replace(':id', contactId),
      icon: 'user',
      loading: !contact,
    },
  ];
};

export default useContactContextRows;
